export default __webpack_public_path__ + "static/media/category-icon-Placeholder.4ee28976.svg";